import useLanguage from "@src/features/contentDetail/hooks/useLanguage";
import { Button } from "@src/lib/ui/Button";
import { useTranslation } from "@src/features/contentDetail/utils/translationSets";
import gql from "graphql-tag";
import React, { useState, useContext } from "react";
import CircleQuestionOutlineIcon from "@src/lib/icons/18px/circle-question-outline";
import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuSeparator,
  DropdownMenuTrigger,
} from "@src/lib/ui/DropdownMenu";
import { SubmitFeedbackDialog } from "./SubmitFeedbackDialog";
import useUpdateIntercom from "@src/features/app/hooks/useUpdateIntercom";
import UserContext from "@src/lib/contexts/UserContext";

const SUPPORT_ENGLISH = "Support";
const GO_TO_HELP_CENTER_ENGLISH = "Go to Help Center";
const CHAT_WITH_SUPPORT_ENGLISH = "Chat with Support";
const SUBMIT_FEEDBACK_ENGLISH = "Submit feedback";
const JOIN_OUR_COMMUNITY_ENGLISH = "Join our community";
const READ_OUR_BLOG_ENGLISH = "Read our blog";
const VIEW_ROADMAP_ENGLISH = "View roadmap";
const VIEW_CHANGELOG_ENGLISH = "View changelog";
const READ_TERMS_OF_SERVICE_ENGLISH = "Read terms of service";

export const HelpButton: React.FC = () => {
  const language = useLanguage();
  const [open, setOpen] = useState(false);
  const [feedbackDialogOpen, setFeedbackDialogOpen] = useState(false);
  const userContext = useContext(UserContext);
  const { show } = useUpdateIntercom(userContext);

  const helpTranslation = useTranslation(SUPPORT_ENGLISH, language || "en");
  const goToHelpCenterTranslation = useTranslation(
    GO_TO_HELP_CENTER_ENGLISH,
    language || "en",
  );
  const chatWithSupportTranslation = useTranslation(
    CHAT_WITH_SUPPORT_ENGLISH,
    language || "en",
  );
  const submitFeedbackTranslation = useTranslation(
    SUBMIT_FEEDBACK_ENGLISH,
    language || "en",
  );
  const joinOurCommunityTranslation = useTranslation(
    JOIN_OUR_COMMUNITY_ENGLISH,
    language || "en",
  );
  const readOurBlogTranslation = useTranslation(
    READ_OUR_BLOG_ENGLISH,
    language || "en",
  );
  const viewRoadmapTranslation = useTranslation(
    VIEW_ROADMAP_ENGLISH,
    language || "en",
  );
  const viewChangelogTranslation = useTranslation(
    VIEW_CHANGELOG_ENGLISH,
    language || "en",
  );
  const readTermsOfServiceTranslation = useTranslation(
    READ_TERMS_OF_SERVICE_ENGLISH,
    language || "en",
  );

  const handleChatWithSupport = () => {
    show();
    setOpen(false);
  };

  return (
    <>
      <DropdownMenu open={open} onOpenChange={setOpen} modal={false}>
        <DropdownMenuTrigger asChild>
          <Button variant="ghost" size="md" className="gap-2">
            <CircleQuestionOutlineIcon />
            {helpTranslation.text || SUPPORT_ENGLISH}
          </Button>
        </DropdownMenuTrigger>
        <DropdownMenuContent align="end" className="w-56">
          <DropdownMenuItem asChild>
            <a href="https://help.opus.so/en/" target="_blank" rel="noreferrer">
              {goToHelpCenterTranslation.text || GO_TO_HELP_CENTER_ENGLISH}
            </a>
          </DropdownMenuItem>
          <DropdownMenuItem onClick={handleChatWithSupport}>
            {chatWithSupportTranslation.text || CHAT_WITH_SUPPORT_ENGLISH}
          </DropdownMenuItem>
          <DropdownMenuItem
            onClick={() => {
              setFeedbackDialogOpen(true);
              setOpen(false);
            }}
          >
            {submitFeedbackTranslation.text || SUBMIT_FEEDBACK_ENGLISH}
          </DropdownMenuItem>
          <DropdownMenuSeparator />
          <DropdownMenuItem asChild>
            <a
              href="https://www.opus.so/promo/office-hours"
              target="_blank"
              rel="noreferrer"
            >
              {joinOurCommunityTranslation.text || JOIN_OUR_COMMUNITY_ENGLISH}
            </a>
          </DropdownMenuItem>
          <DropdownMenuItem asChild>
            <a
              href="https://opustraining.notion.site/opustraining/5c7e7b1164bb44e58f1f5afdeb74bbea?v=fe8fa7f83a5a499493c91f5d6140735f"
              target="_blank"
              rel="noreferrer"
            >
              {viewRoadmapTranslation.text || VIEW_ROADMAP_ENGLISH}
            </a>
          </DropdownMenuItem>
          <DropdownMenuItem asChild>
            <a
              href="https://changelog.opus.so"
              target="_blank"
              rel="noreferrer"
            >
              {viewChangelogTranslation.text || VIEW_CHANGELOG_ENGLISH}
            </a>
          </DropdownMenuItem>
          <DropdownMenuItem asChild>
            <a href="https://www.opus.so/blog" target="_blank" rel="noreferrer">
              {readOurBlogTranslation.text || READ_OUR_BLOG_ENGLISH}
            </a>
          </DropdownMenuItem>
          <DropdownMenuSeparator />
          <DropdownMenuItem asChild>
            <a
              href="https://www.opus.so/legal/terms"
              target="_blank"
              rel="noreferrer"
            >
              {readTermsOfServiceTranslation.text ||
                READ_TERMS_OF_SERVICE_ENGLISH}
            </a>
          </DropdownMenuItem>
        </DropdownMenuContent>
      </DropdownMenu>
      {feedbackDialogOpen && (
        <SubmitFeedbackDialog
          open={feedbackDialogOpen}
          onOpenChange={setFeedbackDialogOpen}
        />
      )}
    </>
  );
};

export default HelpButton;

gql`
  mutation createDashboardFeedback($comment: String!) {
    createDashboardFeedback(input: { comment: $comment }) {
      success
    }
  }
`;
